import { LegacyIntClientId, LegacyProdClientId } from "../Startup/serviceDeskConfig";
import { MsalAuthenticationServiceImplementation } from "./msal/msal-authentication-service";
import { ServiceDeskConfig } from "../Startup/serviceDeskConfig";
export const microsoftTenantIss = "72f988bf-86f1-41af-91ab-2d7cd011db47";
export interface UserTenantService {
  /** returns true if the user is on legacy auth*/
  isUserOnLegacyAuthTenant(): boolean;

  /** returns true if the user is on microsoft tenant*/
  isUserOnMicrosoftTenant(): boolean;
}

export class UserTenantServiceImplementation {
  // @ngInject
  constructor(
    private msalAuthenticationService: MsalAuthenticationServiceImplementation,
    private sdConfig: ServiceDeskConfig
  ) {}

  public isUserOnLegacyAuthTenant(): boolean {
    return this.sdConfig.clientId == LegacyIntClientId || this.sdConfig.clientId == LegacyProdClientId;
  }

  public isUserOnMicrosoftTenant(): boolean {
    if (this.msalAuthenticationService.userInfo.idToken) {
      return (
        this.msalAuthenticationService.userInfo.idToken.iss &&
        this.msalAuthenticationService.userInfo.idToken.iss.includes(microsoftTenantIss)
      );
    }
    return false;
  }
}
